'use client'
import { cn } from '@/shared/lib/classnames'
import { Dialog, DialogContent, DialogContentProps, DialogTitle, DialogTrigger } from '@/ui/dialog'
import { DialogProps } from '@radix-ui/react-dialog'
import { HTMLAttributes, PropsWithChildren, useState } from 'react'

// Визуально скрытый компонент для accessibility
const VisuallyHidden = ({ children }: { children: React.ReactNode }) => (
  <span
    style={{
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0,
    }}
  >
    {children}
  </span>
)

export interface ComponentProps {
  trigger: React.ReactNode
  content?: React.ReactNode
  title?: string
  contentWithControls?: (params: { open: () => void; close: () => void }) => React.ReactNode
  dialogProps?: DialogProps
  contentProps?: HTMLAttributes<HTMLDivElement>
  dialogContentProps?: DialogContentProps
}

export default function Component({
  trigger,
  title,
  content,
  contentWithControls,
  dialogProps,
  contentProps,
  dialogContentProps,
}: PropsWithChildren<ComponentProps>) {
  const [isOpen, setOpen] = useState(false)
  const close = () => setOpen(false)
  const open = () => setOpen(true)

  return (
    <Dialog open={isOpen} onOpenChange={setOpen} {...dialogProps}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        {...dialogContentProps}
        className={cn('sm:max-w-[425px] rounded-sm', dialogContentProps?.className || '')}
      >
        {title ? (
          <DialogTitle className="pr-3">{title}</DialogTitle>
        ) : (
          <VisuallyHidden>
            <DialogTitle>Dialog</DialogTitle>
          </VisuallyHidden>
        )}

        <div {...contentProps} className={cn('max-h-[85dvh] overflow-auto pt-1 px-1', contentProps?.className)}>
          {contentWithControls ? contentWithControls({ close, open }) : content}
        </div>
      </DialogContent>
    </Dialog>
  )
}
